import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
    // this.roles.map(element => {
    //   if (element.toString() == Role.PPORole.toString()) {
    //     this.navigateService.toPpoRequestList();
    //   }
    // });
  }

}
